import { locale } from '../lib/locale';

/**
 * The forms for events, tasks, to-dos, rewards and notes (1.19). German is the master; the
 * examples in placeholders are adapted, not translated word for word.
 */
export const FORMS_TEXT = {
  de: {
    everyone: 'Alle',
    more: 'Mehr Angaben',
    // the event form as lines that open in place (1.25, Mike 20.10.)
    day: 'Tag',
    pickDay: 'Tag wählen',
    place: 'Ort',
    optional: 'optional',
    placeHint: 'Name oder Adresse – beim Tippen kommen Vorschläge.',
    dayOrRange: 'Ersten Tag antippen.',
    pickLastDay: 'Jetzt den letzten Tag antippen – oder denselben noch einmal für nur diesen Tag.',
    timesFor: (from: string, to: string) => `Von ${from} bis ${to}`,
    prevMonth: 'Voriger Monat',
    nextMonth: 'Nächster Monat',
    pickMonth: 'Monat wählen',
    extras: 'Mehr',
    extrasHint: 'Wer bringt?, Mitnehmen, Notiz, Sterne',
    when: 'Wann?',
    otherDay: 'Anderer Tag',
    date: 'Datum',
    cancel: 'Abbrechen',
    saving: 'Speichere …',
    save: 'Speichern',
    failed: 'Das hat nicht geklappt. Bitte nochmal versuchen.',
    remind: 'Erinnern',
    remindHint: 'Beide Eltern bekommen eine Nachricht aufs Handy, die Großen bei ihren Terminen.',
    min10: '10 Min.',
    hour1: '1 Std.',
    eve: 'Vorabend',
    none: 'Keine',
    defaultNone: 'Standard (keine)',
    defaultEve: (hour: string) => `Standard (Vorabend ${hour} Uhr)`,
    defaultMin: (n: string) => `Standard (${n} Min.)`,
    defaultHours: (n: string) => `Standard (${n} Std.)`,
    // event
    what: 'Was?',
    eventExample: 'z. B. Kinderarzt, Fußball, Ausflug',
    forWhom: 'Für wen?',
    fromWhen: 'Ab wann?',
    repeat: 'Wiederholen',
    once: 'Einmalig',
    everyWeek: 'Jede Woche',
    everyNWeeks: (n: string) => `Alle ${n} Wochen`,
    whichDays: 'An welchen Tagen?',
    whichDaysHint: 'Mehrere möglich, z. B. Mo und Mi.',
    untilOptional: 'Bis (optional)',
    untilHint: 'Leer lassen, wenn die Serie weiterläuft.',
    seriesHint: 'Änderungen gelten für alle Termine dieser Serie.',
    time: 'Uhrzeit',
    withTime: 'Mit Uhrzeit',
    allDay: 'Ganztägig',
    from: 'Von',
    moreEvent: 'Ort, Fahrdienst, Mitnehmen',
    where: 'Wo?',
    transport: 'Wer bringt / holt?',
    transportExample: 'z. B. Papa bringt · Mama holt',
    bring: 'Mitnehmen',
    bringHint: 'Mit Komma trennen',
    bringExample: 'Trinkflasche, Regenjacke',
    note: 'Notiz',
    addEvent: 'Termin eintragen',
    // Kalender 2 (1.25)
    never: 'Nie',
    daily: 'Täglich',
    weekdays: 'Werktags',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    everyNDays: (n: string) => `Alle ${n} Tage`,
    everyMonth: 'Jeden Monat',
    everyNMonths: (n: string) => `Alle ${n} Monate`,
    onWhichDay: 'An welchem Tag?',
    monthDate: (d: string) => `Am ${d}. jedes Monats`,
    monthWeekday: (nth: string, weekday: string) => `Am ${nth} ${weekday}`,
    ordinals: ['1.', '2.', '3.', '4.', 'letzten'],
    ends: 'Endet',
    endsSummer: 'Zu den Sommerferien',
    endsOn: 'Am Datum',
    endsAfter: 'Nach … Terminen',
    endsOnLabel: 'Endet am',
    countLabel: 'Anzahl Termine',
    holidays: 'Schulferien',
    pauseHolidays: 'In den Schulferien aussetzen',
    pauseHint: 'Training, Kurse und AGs fallen in den Ferien von selbst aus.',
    nextDates: 'Die nächsten Termine',
    pausedHint: 'durchgestrichen = Ferien',
    pickStart: 'Tippe den Beginn an …',
    pickEnd: '… und dann das Ende.',
    to: 'Bis',
    multiDay: (n: string) => `${n} Tage – steht als ein durchgehender Balken im Kalender.`,
    starsEvent: 'Sterne fürs Abhaken',
    moreEvent2: 'Ort, Wer bringt?, Mitnehmen, Notiz, Sterne',
    scopeTitle: 'Was soll sich ändern?',
    scopeOne: 'Nur diesen Termin',
    scopeOneHint: (day: string) => `${day} – alle anderen bleiben, wie sie sind`,
    scopeFollowing: 'Diesen und alle folgenden',
    scopeFollowingHint: (day: string) => `ab ${day}, die früheren bleiben`,
    scopeAll: 'Alle Termine der Serie',
    scopeAllHint: 'auch die vergangenen',
    // Schichtplan (1.25)
    shiftFor: 'Für wen?',
    // one entry for both plans (1.28)
    planKind: 'Welcher Plan?',
    deletePlan: 'Schichtplan löschen',
    deletePlanSure: 'Ja, ganzen Schichtplan löschen',
    planShift: 'Schichtplan',
    planTimetable: 'Stundenplan',
    shifts: 'Schichten',
    shiftsHint: 'Namen und Zeiten einmal anpassen – sie gelten für den ganzen Plan.',
    shiftName: 'Name',
    shiftNames: { F: 'Früh', S: 'Spät', N: 'Nacht', T: 'Tag' },
    rhythm: 'Rhythmus',
    rhythmHint:
      'Oder selbst zusammentippen: Schicht antippen hängt einen Tag an, ein Tag im Rhythmus wird beim Antippen entfernt.',
    presetRotating: '2 Früh · 2 Spät · 2 Nacht · 3 frei',
    presetWeekly: 'Wochenweise Früh / Spät',
    presetFourFour: '4 an · 4 frei',
    addShift: (name: string) => `＋ ${name}`,
    off: 'frei',
    removeDay: (n: string, name: string) => `Tag ${n}: ${name} – entfernen`,
    rhythmLength: (n: string) => `${n} Tage, dann geht es von vorne los.`,
    dayOne: 'Tag 1 ist am',
    planUntil: 'Bis (leer = offen)',
    planEnds: 'Endet',
    firstWeeks: 'Die ersten 6 Wochen',
    addShiftPlan: 'Schichtplan eintragen',
    // task
    other: 'Andere …',
    starCount: 'Anzahl Sterne',
    range: (min: string, max: string) => `${min} bis ${max}`,
    todo: 'Was ist zu tun?',
    taskExample: 'z. B. Blumen gießen, Zimmer aufräumen',
    onePerson: 'Eine Person',
    shared: 'Geteilt',
    sharedHint: 'wer zuerst kommt',
    forAll: 'Für alle',
    forAllHint: 'freie Wahl',
    who: 'Wer?',
    between: 'Zwischen wem?',
    betweenHint:
      'Mindestens zwei – wer zuerst abhakt, bekommt die Sterne. Zusammen gemacht? Dann teilen sie sich die Sterne.',
    parentStars: 'Sterne von Mama und Papa gehen ans Familienziel – alle sammeln gemeinsam.',
    howOften: 'Wie oft?',
    everyDay: 'Jeden Tag',
    monFri: 'Mo–Fr',
    satSun: 'Sa und So',
    someDays: 'Bestimmte Tage',
    perWeek: '1× pro Woche',
    perWeekend: '1× am Wochenende',
    perMonth: '1× im Monat',
    daypart: 'Tageszeit',
    morning: 'Morgens',
    afternoon: 'Nachmittags',
    evening: 'Abends',
    anytime: 'Egal',
    stars: 'Sterne',
    noStars: 'Keine',
    approval: 'Freigabe',
    approvalAsk: 'Müssen Eltern freigeben?',
    approvalHint: 'Automatisch: ab 10 Sternen ja.',
    auto: 'Automatisch',
    yes: 'Ja',
    noAtOnce: 'Nein, sofort Sterne',
    addTask: 'Aufgabe anlegen',
    // to-do
    todoExample: 'z. B. Milch kaufen, Geschenk besorgen',
    whoCares: 'Wer kümmert sich?',
    byWhen: 'Bis wann?',
    sometime: 'Irgendwann',
    today: 'Heute',
    tomorrow: 'Morgen',
    thisWeek: 'Diese Woche',
    // one form for jobs (1.28)
    oftenAsk: 'Einmal oder regelmäßig?',
    onceJob: 'Einmal',
    regularJob: 'Regelmäßig',
    // reward
    reward: 'Belohnung',
    rewardExample: 'z. B. Pizza-Abend, 30 Min. Medienzeit',
    costs: 'Kostet',
    rewardTip: 'Tipp: kleine Belohnungen für schnelle Erfolge, große als gemeinsames Familienziel.',
    addReward: 'Belohnung anlegen',
    // note
    noteAsk: 'Was soll an die Pinnwand?',
    noteExample: 'z. B. Oma kommt Sonntag zum Kaffee',
    howLong: 'Wie lange hängt der Zettel?',
    untilRemoved: 'Bis ihn jemand abnimmt',
    untilTomorrow: 'Bis morgen',
    untilSunday: 'Bis Sonntag',
    untilDay: (day: string) => `Bis ${day}`,
    pin: 'Anpinnen',
  },
  en: {
    everyone: 'Everyone',
    more: 'More details',
    day: 'Day',
    pickDay: 'Pick a day',
    place: 'Place',
    optional: 'optional',
    placeHint: 'Name or address – suggestions appear as you type.',
    dayOrRange: 'Tap the first day.',
    pickLastDay: 'Now tap the last day – or the same one again for just that day.',
    timesFor: (from: string, to: string) => `From ${from} to ${to}`,
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    pickMonth: 'Pick a month',
    extras: 'More',
    extrasHint: 'Lifts, things to bring, note, stars',
    when: 'When?',
    otherDay: 'Another day',
    date: 'Date',
    cancel: 'Cancel',
    saving: 'Saving …',
    save: 'Save',
    failed: 'That didn’t work. Please try again.',
    remind: 'Remind',
    remindHint: 'Both parents get a message on their phone, the older kids for their own events.',
    min10: '10 min',
    hour1: '1 hr',
    eve: 'Evening before',
    none: 'None',
    defaultNone: 'Default (none)',
    defaultEve: (hour: string) => `Default (evening before, ${hour}:00)`,
    defaultMin: (n: string) => `Default (${n} min)`,
    defaultHours: (n: string) => `Default (${n} hr)`,
    what: 'What?',
    eventExample: 'e.g. doctor, football, day trip',
    forWhom: 'For whom?',
    fromWhen: 'Starting when?',
    repeat: 'Repeat',
    once: 'Once',
    everyWeek: 'Every week',
    everyNWeeks: (n: string) => `Every ${n} weeks`,
    whichDays: 'Which days?',
    whichDaysHint: 'Pick as many as you like, e.g. Mon and Wed.',
    untilOptional: 'Until (optional)',
    untilHint: 'Leave empty if the series keeps going.',
    seriesHint: 'Changes apply to every event in this series.',
    time: 'Time',
    withTime: 'At a time',
    allDay: 'All day',
    from: 'From',
    moreEvent: 'Place, lifts, things to bring',
    where: 'Where?',
    transport: 'Who drops off / picks up?',
    transportExample: 'e.g. Dad drops off · Mum picks up',
    bring: 'Bring',
    bringHint: 'Separate with commas',
    bringExample: 'water bottle, rain jacket',
    note: 'Note',
    addEvent: 'Add event',
    never: 'Never',
    daily: 'Daily',
    weekdays: 'Weekdays',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    everyNDays: (n: string) => `Every ${n} days`,
    everyMonth: 'Every month',
    everyNMonths: (n: string) => `Every ${n} months`,
    onWhichDay: 'On which day?',
    monthDate: (d: string) => `On day ${d} of each month`,
    monthWeekday: (nth: string, weekday: string) => `On the ${nth} ${weekday}`,
    ordinals: ['first', 'second', 'third', 'fourth', 'last'],
    ends: 'Ends',
    endsSummer: 'At the summer holidays',
    endsOn: 'On a date',
    endsAfter: 'After … times',
    endsOnLabel: 'Ends on',
    countLabel: 'Number of times',
    holidays: 'School holidays',
    pauseHolidays: 'Pause in the school holidays',
    pauseHint: 'Practice, classes and clubs skip the holidays by themselves.',
    nextDates: 'The next dates',
    pausedHint: 'crossed out = holidays',
    pickStart: 'Tap the start …',
    pickEnd: '… then the end.',
    to: 'To',
    multiDay: (n: string) => `${n} days – shown as one bar across the calendar.`,
    starsEvent: 'Stars for ticking it off',
    moreEvent2: 'Place, lifts, things to bring, note, stars',
    scopeTitle: 'What should change?',
    scopeOne: 'Only this one',
    scopeOneHint: (day: string) => `${day} – all others stay as they are`,
    scopeFollowing: 'This and all following',
    scopeFollowingHint: (day: string) => `from ${day}, earlier ones stay`,
    scopeAll: 'Every event of the series',
    scopeAllHint: 'past ones too',
    shiftFor: 'For whom?',
    planKind: 'Which plan?',
    deletePlan: 'Delete shift plan',
    deletePlanSure: 'Yes, delete the whole shift plan',
    planShift: 'Shift plan',
    planTimetable: 'Timetable',
    shifts: 'Shifts',
    shiftsHint: 'Set names and times once – they hold for the whole plan.',
    shiftName: 'Name',
    shiftNames: { F: 'Early', S: 'Late', N: 'Night', T: 'Day' },
    rhythm: 'Rhythm',
    rhythmHint: 'Or tap it together: a shift adds a day, tapping a day of the rhythm removes it.',
    presetRotating: '2 early · 2 late · 2 night · 3 off',
    presetWeekly: 'Early / late by the week',
    presetFourFour: '4 on · 4 off',
    addShift: (name: string) => `+ ${name}`,
    off: 'off',
    removeDay: (n: string, name: string) => `Day ${n}: ${name} – remove`,
    rhythmLength: (n: string) => `${n} days, then it starts again.`,
    dayOne: 'Day 1 is on',
    planUntil: 'Until (empty = open)',
    planEnds: 'Ends',
    firstWeeks: 'The first 6 weeks',
    addShiftPlan: 'Add shift plan',
    other: 'Other …',
    starCount: 'Number of stars',
    range: (min: string, max: string) => `${min} to ${max}`,
    todo: 'What needs doing?',
    taskExample: 'e.g. water the plants, tidy your room',
    onePerson: 'One person',
    shared: 'Shared',
    sharedHint: 'first come, first served',
    forAll: 'For everyone',
    forAllHint: 'anyone can do it',
    who: 'Who?',
    between: 'Between whom?',
    betweenHint:
      'At least two – whoever ticks it off first gets the stars. Done together? Then they share the stars.',
    parentStars: 'Stars from Mum and Dad go to the family goal – everyone collects together.',
    howOften: 'How often?',
    everyDay: 'Every day',
    monFri: 'Mon–Fri',
    satSun: 'Sat and Sun',
    someDays: 'Certain days',
    perWeek: 'Once a week',
    perWeekend: 'Once at the weekend',
    perMonth: 'Once a month',
    daypart: 'Time of day',
    morning: 'Mornings',
    afternoon: 'Afternoons',
    evening: 'Evenings',
    anytime: 'Any time',
    stars: 'Stars',
    noStars: 'None',
    approval: 'Approval',
    approvalAsk: 'Do parents need to approve?',
    approvalHint: 'Automatic: yes from 10 stars.',
    auto: 'Automatic',
    yes: 'Yes',
    noAtOnce: 'No, stars straight away',
    addTask: 'Add task',
    todoExample: 'e.g. buy milk, get a present',
    whoCares: 'Who’s taking care of it?',
    byWhen: 'By when?',
    sometime: 'Sometime',
    today: 'Today',
    tomorrow: 'Tomorrow',
    thisWeek: 'This week',
    oftenAsk: 'Once or regular?',
    onceJob: 'Once',
    regularJob: 'Regular',
    reward: 'Reward',
    rewardExample: 'e.g. pizza night, 30 min screen time',
    costs: 'Costs',
    rewardTip: 'Tip: small rewards for quick wins, big ones as a shared family goal.',
    addReward: 'Add reward',
    noteAsk: 'What goes on the pinboard?',
    noteExample: 'e.g. Grandma’s coming for coffee on Sunday',
    howLong: 'How long does the note stay up?',
    untilRemoved: 'Until someone takes it down',
    untilTomorrow: 'Until tomorrow',
    untilSunday: 'Until Sunday',
    untilDay: (day: string) => `Until ${day}`,
    pin: 'Pin it up',
  },
} as const;

export const formsText = FORMS_TEXT[locale];
